import { UIRootState } from "ui/store";
import { MissionTimer } from "../MissionTimer";
import { useSelector } from "react-redux";
import { MissionStatusBadge } from "../MissionStatusBadge";
import { MissionAction } from "../MissionAction";

import './styles.css';
import { useMemo, useRef, useState, useEffect } from "react";

export const DailyMissions: React.FC = () => {

    const dailyMission = useSelector((state: UIRootState) => state.gameUI.missions.dailyMission);

    const ref = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState('120px');

    useEffect(() => {
        const updateHeight = () => {
            if (ref.current) {
                const newHeight = `${ref.current.clientWidth / 3.109}px`;
                setHeight(newHeight);
            }
        };

        const timer = setTimeout(updateHeight, 0);
        
        window.addEventListener('resize', updateHeight);
        
        let resizeObserver: ResizeObserver | null = null;
        if (ref.current && window.ResizeObserver) {
            resizeObserver = new ResizeObserver(updateHeight);
            resizeObserver.observe(ref.current);
        }
        
        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', updateHeight);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [dailyMission]);

    if (!dailyMission) {
        return null;
    }

    const sortedActions = useMemo(() => {
        return dailyMission.actions.sort((a, b) => {
            return a.passed ? 1 : b.passed ? -1 : 0;
        });
    }, [dailyMission.actions]);

    return (
        <div ref={ref} className="daily-missions">
            <MissionTimer endTimeMs={dailyMission.endMs} />
            <MissionStatusBadge height={height} />
            
            <div className="daily-missions-divider"/>

            <div className="daily-missions-actions mission-actions-content">
                {
                    !dailyMission.rewardsClaimed && sortedActions.map((action, index) => (
                        <MissionAction key={index} action={action} />
                    ))
                }
                {
                    dailyMission.rewardsClaimed && (<MissionStatusBadge type="no-missions" height={height} />)
                }
            </div>
        </div>
    );
}